export const PRODUCTION_STAGE = 'prod';

const BASE_DOCUMENT_TITLE = 'SmartSkillTalk';

export interface StageDisplay {
  label: string;
  bgcolor: string;
  documentTitlePrefix: string;
}

const STAGE_DISPLAYS: Record<string, StageDisplay> = {
  feat: {
    label: 'FEAT · 検証環境',
    bgcolor: '#FF6B35',
    documentTitlePrefix: 'FEAT',
  },
  dev: {
    label: 'DEV · 開発環境',
    bgcolor: '#4CAF50',
    documentTitlePrefix: 'DEV',
  },
  staging: {
    label: 'STAGING · 検証環境',
    bgcolor: '#9C27B0',
    documentTitlePrefix: 'STAGING',
  },
};

export function isProductionStage(stage: string): boolean {
  return stage === PRODUCTION_STAGE;
}

export function getStageDisplay(stage: string): StageDisplay | null {
  if (isProductionStage(stage)) {
    return null;
  }

  if (STAGE_DISPLAYS[stage]) {
    return STAGE_DISPLAYS[stage];
  }

  const upper = stage.toUpperCase();
  return {
    label: `${upper} · 非本番環境`,
    bgcolor: '#757575',
    documentTitlePrefix: upper,
  };
}

export function applyEnvironmentDocumentTitle(stage: string): void {
  const display = getStageDisplay(stage);
  document.title = display
    ? `[${display.documentTitlePrefix}] ${BASE_DOCUMENT_TITLE}`
    : BASE_DOCUMENT_TITLE;
}
